import React, { useState } from "react";
import { Col, Row, Input, Form, Button } from "antd";
import { Link } from "react-router-dom";
import { auth } from "api/endpoints";
import { postRequest } from "api";
import { App } from "context/AppContext";
import { UserOutlined } from "@ant-design/icons";
import AuthWrapper from "../AuthWrapper";
import { errorMsg, successMsg } from "utils/msg";

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { darkMode } = App();

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        setLoading(true);
        await postRequest(auth.resetPass, values);
        successMsg("Таны имэйл рүү шинэ нууц үг илгээлээ.", 5);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        errorMsg(error?.Msg);
      });
  };

  return (
    <AuthWrapper>
      <Row
        style={{
          backgroundColor: darkMode ? "#141414" : "#fff",
          padding: "30px 30px 30px 30px",
          borderRadius: "16px",
          boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
        }}
      >
        <Form onFinish={handleSubmit} style={{ width: "450px" }} size="large" form={form}>
          <Row justify="space-between" align="center" style={{ marginBottom: "20px" }}>
            <Col
              style={{
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              Нууц үг сэргээх
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Link to={auth.login}>Нэвтрэх рүү буцах</Link>
            </Col>
          </Row>

          <Form.Item
            name="UserName"
            rules={[
              { required: true, message: "Имэйлээ оруулна уу!" },
              {
                type: "email",
                message: "Имэйлээ шалгана уу!",
              },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Имэйл" allowClear />
          </Form.Item>

          <Form.Item style={{ margin: "0" }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              loading={loading}
              style={{
                width: "100%",
                borderRadius: "8px",
                padding: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>Шинэ нууц үг имэйлээр авах</div>
            </Button>
          </Form.Item>
        </Form>
      </Row>
    </AuthWrapper>
  );
}

export default ForgotPassword;
